import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../state";

export const createTypeJobnumber = createAsyncThunk('createTypeJobnumber', async (data: any) => {
    try {
        const response = await axios({
            method: 'post',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/project/jobnumber/type',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const deleteTypeJobnumber = createAsyncThunk('deleteTypeJobnumber', async (id: string) => {
    try {
        const response = await axios({
            method: 'delete',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/project/jobnumber/type?id=' + id,
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const editTypeJobnumber = createAsyncThunk('editTypeJobnumber', async (data: any) => {
    try {
        const response = await axios({
            method: 'put',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/project/jobnumber/type',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})